import { memo } from 'react'
import styled from 'styled-components'
import Barcode from 'react-barcode'
import QRCode from 'react-qr-code'

import { Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import logoAstroBlack from 'assets/images/logoAstroNEW.png'

const borderColor = theme.palette.strokeColor.dark

function BarcodeSection({ data }) {
  return (
    <LabelWrapper>
      <Container>
        <StyledContainerHeader>
          <div style={{ width: 100 }}>
            <img src={logoAstroBlack} width="100%" height="auto" />
          </div>
          <KoliBox>
            <KoliRow>
              <KoliSoNumber variant="body-smallStrong" fontSize={12} fontWeight={800}>
                {data.supplyOrderNumber}
              </KoliSoNumber>
            </KoliRow>
            <KoliRow>
              <Typography variant="body-smallStrong">No Koli {data.koliNumber}</Typography>
            </KoliRow>
          </KoliBox>
        </StyledContainerHeader>

        <StyledContainerTable>
          <StyledTable>
            <tr>
              <td>
                <Typography variant="body-tinyStrong">Asal</Typography>
              </td>
              <td>
                <ClampedTypography variant="body-smallStrong" fontWeight={900}>
                  {data.origin}
                </ClampedTypography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body-tinyStrong">Tujuan</Typography>
              </td>
              <td>
                <ClampedTypography variant="display-tiny" fontWeight={900}>
                  {data.destination}
                </ClampedTypography>
              </td>
            </tr>

            <tr>
              <td>
                <Typography variant="body-tinyStrong">SO Remarks</Typography>
              </td>
              <td>
                <SingleLineTypography variant="body-smallStrong">
                  {data.remarks || '-'}
                </SingleLineTypography>
              </td>
            </tr>

            {data.priority && (
              <tr>
                <td>
                  <Typography variant="body-tinyStrong">Prioritas</Typography>
                </td>
                <td>
                  <Typography variant="body-smallStrong">{data.priority}</Typography>
                </td>
              </tr>
            )}
          </StyledTable>
        </StyledContainerTable>

        <Footer>
          <QRWrap>
            <QRCode value={data?.koliCode} style={{ width: '100%', height: '100%' }} />
          </QRWrap>
          <BarcodeWrap>
            <Barcode value={data?.koliCode} displayValue={false} height={64} width={2} margin={0} />
            <Typography variant="body-tinyStrong" lineHeight="1.2">
              {data?.koliCode}
            </Typography>
          </BarcodeWrap>
        </Footer>
      </Container>
    </LabelWrapper>
  )
}

export default memo(BarcodeSection)

const LabelWrapper = styled.div`
  width: 100mm;
  height: 100mm;
  box-sizing: border-box;
  padding: 2mm;
  background: white;

  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    page-break-inside: avoid;
    break-inside: avoid;

    @page {
      size: 100mm 100mm;
      margin: 0mm;
    }
  }
`

const Container = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid black;
  border-radius: 4px;
  padding: 3mm;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const StyledContainerHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 10px;
  flex-shrink: 0;
`

const KoliBox = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 6px;
  overflow: hidden;
  flex: 1;
`

const KoliRow = styled.div`
  padding: 4px 8px;
  text-align: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${borderColor};
  }
`

const KoliSoNumber = styled(Typography)`
  white-space: nowrap;
`

const ClampedTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`

const SingleLineTypography = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`

const QRWrap = styled.div`
  width: 18mm;
  height: 18mm;
  flex-shrink: 0;
`

const BarcodeWrap = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    width: 100%;
    height: auto;
  }
`

const StyledTable = styled.table`
  width: 100%;
  height: 100%;
  border-radius: 4;
  border-collapse: collapse;

  & tr {
    & td {
      vertical-align: middle;
      padding: 0px 8px;
      border-bottom: 1px solid ${borderColor};
      text-align: left;

      & > *:not(${ClampedTypography}) {
        display: block;
      }

      &:first-child {
        border-right: 1px solid ${borderColor};
        width: fit-content;
        white-space: nowrap;
      }

      &:last-child {
        width: 100%;
      }
    }

    &:last-child {
      & td {
        border-bottom: none;
      }
    }
  }
`

const StyledContainerTable = styled.div`
  flex: 1;
  min-height: 0;
  margin: 8px 0;
  border-radius: 6px;
  border: 1px solid ${borderColor};
  overflow: hidden;
`
